import React, { Component, Fragment } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carouselSettings: {},
    };
    this.setCarouselSettings = this.setCarouselSettings.bind(this);
  }

  componentDidMount() {
    this.setCarouselSettings(this.props);
  }

  setCarouselSettings({ values }) {
    this.setState((previousState) => ({
      ...previousState,
      carouselSettings: {
        showStatus: false,
        showThumbs: false,
        infiniteLoop: values.length > 1 ? true : false,
        showIndicators: values.length > 1 ? true : false,
        showArrows: values.length > 1 ? true : false,
        autoPlay: true,
      },
    }));
  }

  render() {
    const { values } = this.props;

    if (values?.length <= 1) {
      return (
        <div className="slider__slide">
          <img
            alt={values[0].title}
            className="slider__image"
            src={values[0].image}
          />
          <div className="slider__content">
            {values[0].title && (
              <h2 className="slider__text">{values[0].title}</h2>
            )}
            {values[0].url && values[0].text && (
              <a
                className={`slider__link ${values[0].button}`}
                href={values[0].url}
              >
                {values[0].text}
              </a>
            )}
          </div>
          {values[0].theme && (
            <div
              className={`slider__overlay slider__overlay--${values[0].theme}`}
            ></div>
          )}
          <div className={`badge-container ${values[0].badgePosition}`}>
            <div className={`badge ${values[0].badgeBackground}`}>
                <span>{values[0].badgeText}</span>
            </div>
          </div>
        </div>
      );
    }

    if (values?.length > 1) {
        return (
            <Carousel {...this.state.carouselSettings}>
                {values.map((value, index) => (
                    <div className="slider__slide" key={`figure${index}`}>
                        <img
                            alt={value.title}
                            className="slider__image"
                            src={value.image}
                        />
                        <div className="slider__content">
                            {value.title && <h2 className="slider__text">{value.title}</h2>}
                            {value.url && value.text && (
                                <a className={`slider__link ${value.button}`} href={value.url}>
                                    {value.text}
                                </a>
                            )}
                        </div>
                        {value.theme && (
                            <div
                                className={`slider__overlay slider__overlay--${value.theme}`}
                            ></div>
                        )}
                        <div className="badge-container">
                            <div
                                className={`badge ${value.badgePosition} ${value.badgeBackground}`}
                            >
                                <span>{value.badgeText}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </Carousel>
        );
    }
  }
}
export default Slider;
